<template>
  <div></div>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    beforeMount() {
      try {
        this.$auth.logout();
        const logoutTarget = this.$config.values['auth-redirects-logout-target'] ?? this.$config.values['auth-redirects-login'];
        this.$router.push(logoutTarget);
      } catch (error) {
        this.$log.error('Unable to log out an error occurred');
        this.$log.error(error);
      }
    },
  });
</script>
